import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/containers/SavingsCalculator/savingsCalculator.scss';
// import '../../../styles/containers/Prayer/components/select-faith.scss';
// import Faiths from './Faiths';
// import faiths from '../../../constants/PrayerFaithsConstants';
import React from 'react'
import {useEffect, useState} from 'react'
import useMoengage from '../../../hooks/useMoengage';
import NextButton from './NextButton';
import {Routes} from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import NavigationSection from './NavigationSection';
import SavingsCalculatorConstants from '../../../constants/SavingsCalculatorConstants'
import SavingsCard from './SavingsCard';
import RoutingService from '../../../services/RoutingService';
import { useHistory, useLocation } from 'react-router-dom';

function SelectMySavings() {
  const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSavings, setSelectedSavings] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const trackEvent = useMoengage()[1];
  useEffect(() => {
      const paramString = window.location.href.split('?')[1];
      const queryString = new URLSearchParams(paramString);
      let userIdParam;
      queryString.forEach((value, key) => {
        if (key === 'userId') userIdParam = value;
      });
      if (!userIdParam) return;
      else if (!location.amount) history.replace(`/savingsCalculator/earnings?userId=${userIdParam}`);
      else {
          setUserId(userIdParam);
          setIsLoading(false);
      };
  },[])

  const handleNextButtonClick = function () {
    RoutingService.gotoMySavingsAmount({
        search:`userId=${userId}&savingsAmount=${selectedSavings.substring(1)}`,
        amount: selectedSavings,
      });
      trackEvent('weekly_savings', {savings: selectedSavings});
  }

  return isLoading ? (
    <AnimatedLoader containerStyle={{ height: '100vh' }} />
  ) : (<div className='__main-container' style={{ minHeight: '100vh' }}>
    <NavigationSection path={`${Routes.SELECT_EARNINGS}`} search={`userId=${userId}`} />
    <div className='__horizontal-center select-faith-heading' style={{
      marginTop:'8%',
    }}>How much are you comfortable in saving every week?</div>
    <div className="container-fluid" style={{ marginTop:'8%'}}>

    <div className="row justify-content-between">      
            <div className="col d-flex justify-content-center col-margin" onClick={() => 
              setSelectedSavings('₹500')
            }>
              {selectedSavings == '₹500' && (
                <SavingsCard money='₹500' selectedSavings={selectedSavings} color={selectedSavings}></SavingsCard>
              )}  
              {selectedSavings != '₹500' && (
                <SavingsCard money='₹500'></SavingsCard>
              )} 
            </div>
            <div className="col d-flex justify-content-center col-margin" onClick={() => 
              setSelectedSavings('₹1000')
            }>
            {selectedSavings == '₹1000' && (
                <SavingsCard money='₹1000' selectedSavings={selectedSavings} color={selectedSavings}></SavingsCard>
              )}  
              {selectedSavings != '₹1000' && (
                <SavingsCard money='₹1000'></SavingsCard>
              )}             </div>
      </div>

      <div className="row justify-content-between">      
            <div className="col d-flex justify-content-center col-margin" onClick={() => 
              setSelectedSavings('₹2000')
            }>
            {selectedSavings == '₹2000' && (
                <SavingsCard money='₹2000' selectedSavings={selectedSavings} color={selectedSavings}></SavingsCard>
              )}  
              {selectedSavings != '₹2000' && (
                <SavingsCard money='₹2000'></SavingsCard>
              )}             </div>
            <div className="col d-flex justify-content-center col-margin" onClick={() => 
              setSelectedSavings('₹5000')
            }>
            {selectedSavings == '₹5000' && (
                <SavingsCard money='₹5000' selectedSavings={selectedSavings} color={selectedSavings}></SavingsCard>
              )}  
              {selectedSavings != '₹5000' && (
                <SavingsCard money='₹5000'></SavingsCard>
              )}             </div>
      </div>
      

</div>
<div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop:'8%',
        }}>
          <p style={{
            position: 'absolute',
            width: '289px',
            height: '36px',
            fontFamily: 'Open Sans',
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: '24px',
            lineHeight: '150%',
            textAlign: 'center',
            color: selectedSavings== null?'#111111':'#C69A00',
          }}>every week</p>

        </div>
        <NextButton handleClick={handleNextButtonClick} selectedEarning={selectedSavings}/>

    </div>
  )
}

export default SelectMySavings





//earning.value== selectedEarning ?'3px solid #C69A00'
//earning.value== selectedEarning ?'#C69A00'